import { SearchInputWithSelect } from "components/ui/search-input-with-select";
import React from "react";

export type ClientMapSearchType = "bestName" | "anyName" | "phone";

const searchTypeOptions: { value: ClientMapSearchType; label: string }[] = [
    { value: "bestName", label: "Client/best contact name" },
    { value: "anyName", label: "Client/any contact name" },
    { value: "phone", label: "Phone number" },
];

interface ClientMapSearchInputProps {
    searchText: string;
    onSearchTextChange: (value: string) => void;
    searchType: ClientMapSearchType;
    onSearchTypeChange: (value: ClientMapSearchType) => void;
}

export const ClientMapSearchInput: React.FC<ClientMapSearchInputProps> = props => {
    const { searchText, onSearchTextChange, searchType, onSearchTypeChange } = props;

    return (
        <SearchInputWithSelect
            className="w-96"
            searchText={searchText}
            onSearchTextChange={onSearchTextChange}
            searchPlaceholder="Search"
            selectValue={searchType}
            onSelectChange={onSearchTypeChange}
            selectOptions={searchTypeOptions}
        />
    );
};
